<template>
  <div class="card-header">
    <div class="card-header-col card-col w50">
      <!-- <Checkbox @change="onChange"/> -->
    </div>
    <div class="card-header-col card-col w150">
      Indent ID
    </div>
    <div class="card-header-col card-col w150">
      Date
    </div>
    <div class="card-header-col card-col w200">
      Route
    </div>
    <div class="card-header-col card-col w200">
      VEHICLE TYPE
    </div>
    <div class="card-header-col card-col payment-actions">

    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      isIndeterminate: true,
    };
  },

  methods: {
    onChange(status) {
      this.$emit('selectall', status);
    },
  },
};
</script>

<style lang="scss">

</style>
